(function () {
  if (window.__badgerBlankWarningBound) return;
  window.__badgerBlankWarningBound = true;

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest('button[name="checkout"]');
    if (!checkoutButton) return;
    if (checkoutButton.closest('.cart-blank-warning')) return;

    var container = checkoutButton.closest('.cart-notification__links, .cart__ctas');
    if (!container) return;

    var warning = container.querySelector('.cart-blank-warning');
    if (warning) {
      event.preventDefault();
      warning.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });
})();